package devxertech.com.pages.dashboard.clientFeedbackSection


import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.OverflowWrap
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TouchAction
import com.varabyte.kobweb.compose.css.TransformOrigin
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onTouchEnd
import com.varabyte.kobweb.compose.ui.modifiers.onTouchMove
import com.varabyte.kobweb.compose.ui.modifiers.onTouchStart
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.overflowWrap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.touchAction
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transformOrigin
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.wordBreak
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaAngleRight
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import devxertech.com.utils.imageLoading
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Span
import org.w3c.dom.get

enum class SlideDirection { LEFT, RIGHT }

@Composable
fun ClientFeedback(breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()
    var currentIndex by remember { mutableStateOf(0) }
    var isUserInteracting by remember { mutableStateOf(false) }
    var slideDirection by remember { mutableStateOf(SlideDirection.RIGHT) }
    var touchStartX by remember { mutableStateOf<Float?>(null) }
    var dragOffsetX by remember { mutableStateOf(0f) }
    var isDragging by remember { mutableStateOf(false) }
    val clients = listOf(
        mapOf(
            "image" to Res.Image.testimonial_3,
            "name" to "Jhon Wick",
            "country" to "France",
            "description" to "Devxer Technologies is very professional and our business is very happy with the end product."
        ),
        mapOf(
            "image" to Res.Image.testimonial_4,
            "name" to "Phillips",
            "country" to "USA",
            "description" to "Devxer Tech has proven to be a talented group of offshore developers. Their leadership and communication are commendable; they organize the team effectively, provide clear feedback and guidance, and complete deliverables on time and on budget."
        ),
        mapOf(
            "image" to Res.Image.testimonial_2,
            "name" to "Philander",
            "country" to "Germany",
            "description" to "Devxer Technologies is a versatile and multi-talented team that works its heart out in all dimensions of professionalism. They handle pressure very well and maintain a superb sense of integrity in all situations."
        ),
        mapOf(
            "image" to Res.Image.testimonial,
            "name" to "Matteo",
            "country" to "Cyprus",
            "description" to "Devxer Technologies is very professional and our business is very happy with the end product."
        ),
        mapOf(
            "image" to Res.Image.testimonial_5,
            "name" to "Martin Luther",
            "country" to "Italy",
            "description" to "Devxer Tech has proven to be a talented group of offshore developers. Their leadership and communication are commendable; they organize the team effectively, provide clear feedback and guidance, and complete deliverables on time and on budget."
        ),
        mapOf(
            "image" to Res.Image.faran,
            "name" to "Faran",
            "country" to "Canada",
            "description" to "Devxer Technologies is a versatile and multi-talented team that works its heart out in all dimensions of professionalism. They handle pressure very well and maintain a superb sense of integrity in all situations."
        ),
    )

    // Auto-slide effect
    LaunchedEffect(isUserInteracting) {
        while (true) {
            kotlinx.coroutines.delay(4000)

            if (!isUserInteracting) {
                currentIndex = (currentIndex + 1) % clients.size
            }
        }
    }

    LaunchedEffect(currentIndex) {
        if (isUserInteracting) {
            kotlinx.coroutines.delay(3000)
            isUserInteracting = false
        }
    }


    val totalDots = clients.size
    val dotSize = 10.px
    val dotGap = 10.px
    val visibleCards =
        if (window.screen.width < 786) {
            // Mobile → 1 card
            listOf(currentIndex)

        } else if (window.screen.width > 1400) {
            // Large screens → 3 cards
            listOf(
                (currentIndex - 1 + clients.size) % clients.size,
                currentIndex,
                (currentIndex + 1) % clients.size
            )

        } else {
            // Medium screens → 2 cards
            listOf(
                currentIndex,
                (currentIndex + 1) % clients.size
            )
        }


    fun positionFor(index: Int): CardPosition {

        // 1 card (mobile)
        if (visibleCards.size == 1) {
            return if (index == visibleCards[0])
                CardPosition.CENTER
            else
                CardPosition.OFFSCREEN
        }

        // 2 cards (tablet)
        // 2 cards (tablet) → BOTH CENTER
        if (visibleCards.size == 2) {
            return if (visibleCards.contains(index))
                CardPosition.CENTER
            else
                CardPosition.OFFSCREEN
        }

        // 3 cards (desktop)
        return when (index) {
            visibleCards[0] -> CardPosition.LEFT
            visibleCards[1] -> CardPosition.CENTER
            visibleCards[2] -> CardPosition.RIGHT
            else -> CardPosition.OFFSCREEN
        }
    }



    Column(
        modifier = Modifier.fillMaxWidth()
            .backgroundColor(Color.white)
            .padding(top = if (breakpoint < Breakpoint.MD) 0.px else 20.px, bottom = 40.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(
            "Client Feedback",
            modifier = Modifier
                .margin(
                    top = if (breakpoint < Breakpoint.MD) 0.px else 40.px,
                    bottom = if (breakpoint < Breakpoint.MD) 0.px else 10.px
                )
                .fontSize(18.px)
                .fontFamily(Constants.FONT_FAMILY)
                .color(sitePalette.commonSecondaryButtonColor.rgb)
        )

        Row(
            modifier = Modifier.fillMaxWidth().margin(bottom = 10.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            SpanText(
                "Client ",
                modifier = Modifier.fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontWeight(FontWeight.Bold)
                    .color(sitePalette.commonSecondaryButtonColor.rgb)
            )
            SpanText(
                "Testimonials",
                modifier = Modifier
                    .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontWeight(FontWeight.Bold)
                    .color(sitePalette.primary.rgb)
            )
        }

        Row(
            modifier = Modifier.fillMaxWidth()
                .margin(topBottom = 60.px)
                .padding(leftRight = if (window.screen.width < 475) 10.px else 30.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            FaAngleLeft(
                modifier = Modifier
                    .margin(right = 20.px)
                    .color(sitePalette.primary.rgb)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        isUserInteracting = true
                        slideDirection = SlideDirection.LEFT
                        currentIndex = (currentIndex + 1) % clients.size
                    },
                size = if (breakpoint >= Breakpoint.SM) IconSize.XXL else IconSize.SM
            )

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(top = if (breakpoint < Breakpoint.MD) (-20).px else 0.px)
                    .maxWidth(1300.px),
                contentAlignment = Alignment.Center
            ) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .styleModifier {
                            property("perspective", "1200px")
                            property("transform-style", "preserve-3d")
                        },
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically
                ) {

                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .gap(30.px)
                            .height(if (breakpoint >= Breakpoint.MD) 370.px else 320.px)
                            .overflow(if (window.screen.width < 1600) Overflow.Hidden else Overflow.Visible)
                            .touchAction(TouchAction.PanY) // vertical scroll allow
                            .onTouchStart { event ->
                                touchStartX = event.touches[0]?.clientX?.toFloat()
                                dragOffsetX = 0f
                                isDragging = true
                                isUserInteracting = true
                            }
                            .onTouchMove { event ->
                                val startX = touchStartX ?: return@onTouchMove
                                val currentX = event.touches[0]?.clientX?.toFloat()
                                if (currentX != null) {
                                    dragOffsetX = currentX - startX
                                }
                            }
                            .onTouchEnd {
                                val threshold = 80f
                                val offset = dragOffsetX

                                isDragging = false
                                dragOffsetX = 0f
                                touchStartX = null

                                if (kotlin.math.abs(offset) > threshold) {

                                    if (offset > 0) {
                                        // 👈 finger moved RIGHT → content moves LEFT → PREVIOUS
                                        slideDirection = SlideDirection.RIGHT
                                        currentIndex =
                                            (currentIndex - 1 + clients.size) % clients.size

                                    } else {
                                        // 👉 finger moved LEFT → content moves RIGHT → NEXT
                                        slideDirection = SlideDirection.LEFT
                                        currentIndex =
                                            (currentIndex + 1) % clients.size
                                    }
                                }

                                touchStartX = null
                            }
                            .styleModifier {
                                property("position", "relative")
                                property("transform-style", "preserve-3d")
                            },
                        contentAlignment = Alignment.Center
                    ) {
                        clients.forEachIndexed { index, client ->
                            ClientsData(
                                index = index,
                                visibleCards = visibleCards,
                                image = client["image"] as String,
                                name = client["name"] as String,
                                country = client["country"] as String,
                                description = client["description"] as String,
                                breakpoint = breakpoint,
                                position = positionFor(index),
                                slideDirection = slideDirection,
                                isDragging = isDragging,
                                dragOffsetX = dragOffsetX
                            )
                        }
                    }
                }
            }

            FaAngleRight(
                modifier = Modifier
                    .margin(left = 20.px)
                    .color(sitePalette.primary.rgb)
                    .cursor(Cursor.Pointer)
                    .zIndex(999)
                    .onClick {
                        isUserInteracting = true
                        slideDirection = SlideDirection.RIGHT
                        currentIndex = (currentIndex + 1) % clients.size
                    },
                size = if (breakpoint >= Breakpoint.SM) IconSize.XXL else IconSize.SM
            )
        }

        // Pagination dots
        val dotsIndex =
            if (slideDirection == SlideDirection.LEFT)
                (clients.size - currentIndex) % clients.size
            else
                currentIndex

        Row(
            modifier = Modifier.gap(dotGap),
            verticalAlignment = Alignment.CenterVertically
        ) {
            (0 until totalDots).forEach { index ->
                Box(
                    modifier = Modifier
                        .size(if (index == dotsIndex) 35.px else dotSize, dotSize)
                        .backgroundColor(
                            if (index == dotsIndex)
                                sitePalette.commonSecondaryButtonColor.rgb
                            else
                                Color("#bbb")
                        )
                        .borderRadius(if (index == dotsIndex) 6.px else 50.percent)
                        .cursor(Cursor.Pointer)
                        .transition(Transition.of("all", 0.4.s))
                        .onClick {
                            slideDirection =
                                if (index > currentIndex)
                                    SlideDirection.LEFT
                                else
                                    SlideDirection.RIGHT

                            currentIndex = index
                        }
                )
            }
        }

    }
}

@Composable
fun ClientsData(
    image: String,
    name: String,
    country: String,
    description: String,
    breakpoint: Breakpoint,
    position: CardPosition,
    index: Int,
    visibleCards: List<Int>,
    slideDirection: SlideDirection,
    isDragging: Boolean,
    dragOffsetX: Float
) {
    val sitePalette = ColorMode.current.toSitePalette()

    Column(
        modifier = Modifier
            .width(if (breakpoint >= Breakpoint.MD) 400.px else if (window.screen.width < 375) 240.px else 300.px)
            .thenIf(breakpoint >= Breakpoint.MD) {
                Modifier.height(320.px)
            }
            .borderRadius(20.px)
            .padding(topBottom = 20.px)
            .margin(leftRight = 10.px, bottom = if (breakpoint < Breakpoint.MD) 0.px else 20.px)
            .backgroundImage(
                linearGradient(
                    LinearGradient.Direction.ToRight,
                    sitePalette.hoverGradientTeam.rgb,
                    sitePalette.hoverGradientOne.rgb
                )
            )
            .transformOrigin(transformOrigin = TransformOrigin.Center)
            .position(Position.Absolute)
            .transition(
                if (isDragging)
                    Transition.None
                else
                    Transition.of("transform", 0.6.s)
            )
            .opacity(
                if (position == CardPosition.OFFSCREEN) 0 else 1
            )
            .transform {
                when (position) {
                    CardPosition.LEFT -> {
                        translateX((-420).px)
                        rotateY(if (window.screen.width in 1400.. 1720) 30.deg else 55.deg)
                        scale(0.95)
                    }

//                    CardPosition.CENTER -> {
//
//                        val offset =
//                            if (visibleCards.size == 2) {
//                                if (index == visibleCards[0]) (-220).px else 220.px
//                            } else {
//                                0.px
//                            }
//
//                        translateX(offset)
//                        rotateY(0.deg)
//                        scale(1.0)
//                    }

                    CardPosition.CENTER -> {
                        val baseOffset =
                            if (visibleCards.size == 2) {
                                if (index == visibleCards[0]) (-220).px else 220.px
                            } else {
                                0.px
                            }

                        val drag =
                            if (isDragging) dragOffsetX.px else 0.px

                        translateX(baseOffset + drag)
                        rotateY(0.deg)
                        scale(1.0)
                    }


                    CardPosition.RIGHT -> {
                        translateX(420.px)
                        rotateY(if (window.screen.width in 1400.. 1720) (-30).deg else (-50).deg)
                        scale(0.95)
                    }

                    CardPosition.OFFSCREEN -> {
                        // Move offscreen in the opposite direction to create continuous flow
                      if (window.screen.width < 800){
                            translateX((700).px)
                        } else {
                            translateX((700).px)
                        }
                        scale(0.8)
                    }
                }
            },
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Image(src = image, description = name, modifier = Modifier.size(71.px).borderRadius(100.px)
            .imageLoading(image, lazy = true, sizes = "71px"))
        SpanText(
            name, modifier = Modifier.margin(top = 10.px).fontSize(16.px).fontFamily(
                Constants.FONT_FAMILY).fontWeight(600).letterSpacing(0.9.px)
                .color(sitePalette.bodyBackgroundSecondary.rgb)
        )
        SpanText(
            country, modifier = Modifier.margin(top = 5.px).fontSize(16.px).fontFamily(
                Constants.FONT_FAMILY).fontWeight(600).letterSpacing(0.9.px)
                .color(sitePalette.bodyBackgroundSecondary.rgb)
        )
//        Image(
//            src = Res.Image.inverted_commas_starting,
//            modifier = Modifier.width(9.px).alignSelf(AlignSelf.SelfStart)
//                .margin(left = 8.px, bottom = (-4).px)
//                .color(sitePalette.bodyBackgroundSecondary.rgb)
//        )
        Span(
            attrs = Modifier.fillMaxWidth()
                .flexWrap(FlexWrap.Wrap).padding(leftRight = 15.px).toAttrs()
        ) {
            SpanText(
                description,
                modifier = Modifier.margin(top = 5.px)
                    .width(if (breakpoint >= Breakpoint.MD) 390.px else 370.px)
                    .fontSize(if (breakpoint >= Breakpoint.MD) 15.px else 12.px).fontFamily(
                        Constants.FONT_FAMILY
                    ).color(sitePalette.bodyBackgroundSecondary.rgb)
                    .wordBreak(WordBreak.Normal).overflowWrap(OverflowWrap.BreakWord).textAlign(
                        TextAlign.Center
                    )
            )
//            Image(
//                src = Res.Image.inverted_commas_ending,
//                modifier = Modifier.width(9.px).margin(left = 2.px, bottom = 6.px)
//                    .color(sitePalette.bodyBackgroundSecondary.rgb)
//            )
        }
    }
}

enum class CardPosition {
    LEFT, CENTER, RIGHT, OFFSCREEN
}
